import { render, staticRenderFns } from "./orgList.vue?vue&type=template&id=88731298&scoped=true"
import script from "./orgList.vue?vue&type=script&lang=js"
export * from "./orgList.vue?vue&type=script&lang=js"
import style0 from "./orgList.vue?vue&type=style&index=0&id=88731298&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88731298",
  null
  
)

export default component.exports